module.exports = __webpack_public_path__ + "media/images/icn-cal-8f4158a099b23afd8d026a69a1134cb6.png";